/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'signup-wizard-layout',
  templateUrl: './signup-wizard-layout.component.html',
  styleUrls: ['./signup-wizard-layout.component.scss'],
})
export class SignupWizardLayoutComponent implements OnInit {

  items: MenuItem[] = [];

  constructor() {}

  ngOnInit(): void {
    this.items = [{
      label: 'signup.account-type.title',
      routerLink: 'account-type'
    },
      {
        label: 'signup.company-info',
        routerLink: 'company-info'
      },
      {
        label: 'signup.subscription',
        routerLink: 'subscription'
      },
      {
        label: 'signup.payment-info',
        routerLink: 'payment-info'
      },
      {
        label: 'signup.contact',
        routerLink: 'first-contact'
      }
    ];
  }
}

